<div class="tree-edit-dialog">
  <h2>Change Supervisor</h2>
  <div class="sub" style="color:#424242; opacity:0.7; font-size:12px; margin-bottom:12px;">
    Update who this employee reports to.
  </div>

  <div class="current-emp">
    <div class="avatar">
      {{
        data.employee.initials ||
          (data.employee.employee_name | slice: 0:2) | uppercase
      }}
    </div>
    <div>
      <div class="name">{{ data.employee.employee_name }}</div>
      <div class="sub">
        {{ data.employee.region }}
        <span *ngIf="data.employee.employeetype"> &middot; {{ data.employee.employeetype }}</span>
      </div>
    </div>
  </div>

  <div class="reporting-chain" *ngIf="reportingChain.length > 0">
    <div class="chain-title">Reporting chain</div>
    <div class="chain-list">
      <span class="chain-link chain-self">
        {{ data.employee.employee_name }}
      </span>
      <ng-container *ngFor="let sup of reportingChain">
        <span class="chain-arrow">&rarr;</span>
        <span class="chain-link">{{ sup.employee_name.trim() }}</span>
      </ng-container>
    </div>
    <div class="chain-hint">
      Reports to
      <strong>{{ reportingChain[0].employee_name.trim() }}</strong>
      <span *ngIf="reportingChain.length > 1">
        , up through
        {{
          reportingChain[reportingChain.length - 1].employee_name.trim()
        }}
      </span>
      .
    </div>
  </div>

  <div class="reporting-chain no-chain" *ngIf="reportingChain.length === 0">
    <div class="chain-title">Reporting chain</div>
    <div class="chain-hint">
      {{ data.employee.employee_name }} is top-level &mdash; no supervisor
      assigned.
      <div style="font-size:10px;opacity:0.5;margin-top:4px;font-family:monospace;">
        Debug: supervisingrater={{ data.employee.supervisingrater || 'null' }},
        fullEmp={{ data.fullEmployees?.length || 0 }},
        allEmp={{ data.allEmployees?.length || 0 }}
      </div>
    </div>
  </div>

  <mat-form-field appearance="outline">
    <mat-label>New supervisor</mat-label>
    <input
      type="text"
      matInput
      [formControl]="supervisorCtrl"
      [matAutocomplete]="supAuto"
      placeholder="Start typing a name..."
    />
    <mat-autocomplete
      #supAuto="matAutocomplete"
      [displayWith]="displaySupervisor"
      (optionSelected)="onSelectSupervisor($event.option.value)"
      panelClass="employee-tree-panel"
    >
      <mat-option
        *ngFor="let sup of filteredSupervisors$ | async"
        [value]="sup"
      >
        {{ sup.employee_name }}
        <span style="color:#424242; opacity:0.6; font-size:12px;" *ngIf="sup.region">
          &mdash; {{ sup.region }}</span
        >
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>

  <div
    *ngIf="selectedSupervisor"
    style="font-size:12px; color:#75bd4e; margin-bottom:8px;"
  >
    Reports to: <strong>{{ selectedSupervisor.employee_name }}</strong>
  </div>
  <div
    *ngIf="!selectedSupervisor"
    style="font-size:12px; color:#424242; opacity:0.7; margin-bottom:8px;"
  >
    No supervisor assigned (top-level).
  </div>

  <button
    mat-stroked-button
    (click)="clearSupervisor()"
    *ngIf="selectedSupervisor"
    style="margin-bottom: 8px;"
  >
    Remove Supervisor
  </button>

  <div class="dialog-actions">
    <button mat-stroked-button (click)="cancel()" [disabled]="saving">
      Cancel
    </button>
    <button
      mat-raised-button
      class="save-btn"
      (click)="save()"
      [disabled]="saving"
    >
      {{ saving ? "Saving..." : "Save" }}
    </button>
  </div>
</div>
